import axios, { AxiosError } from 'axios';

import { InquiryRequestData } from '@/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CREATE_INQUIRY_API_ENDPOINT } from '@/constants';
import { toast } from 'react-toastify';
import { executeCaptcha } from './executeCaptcha';

export const useCreateInquiry = (
  onSuccess: (data: string | null, variables: { sendWhatsapp: boolean }) => void,
  onError?: (statusCode: number | undefined, variables: { sendWhatsapp: boolean }) => void,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    {
      whatsappMessageId: null | string;
    },
    AxiosError,
    InquiryRequestData
  >({
    mutationFn: async ({ objectId, inquiryObj }) => {
      const captchaToken = await executeCaptcha();

      return axios
        .post(`${CREATE_INQUIRY_API_ENDPOINT}/${objectId}`, {
          ...inquiryObj,
          captchaToken,
        })
        .then((res) => res.data);
    },
    onError: (error, variables) => {
      const statusCode = error.response?.status;
      if (onError) {
        onError(statusCode, variables.inquiryObj);
      } else {
        toast.error(error.message);
      }
      console.error(error);
    },
    onSuccess: (data, variables) => {
      const { objectId, inquiryObj } = variables;

      void queryClient.invalidateQueries({ queryKey: ['broker-messages', String(objectId)] });
      void queryClient.invalidateQueries({ queryKey: ['housing-object', String(objectId)] });
      void queryClient.invalidateQueries({ queryKey: ['broker-last-message'] });
      void queryClient.invalidateQueries({ queryKey: ['housing-list'] });
      void queryClient.invalidateQueries({ queryKey: ['watchList'] });

      onSuccess?.(data.whatsappMessageId, inquiryObj);
    },
  });
};
